export enum BulletColor {
  NEUTRAL = 'neutral',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
  YELLOW = 'yellow',
}
